export default function configuracoes(podeAcessar) {
  return [
    {
      name: 'Inicio',
      icon: 'fa fa-th-large fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: true,
      link: '/app/config/inicio',
    },
    {
      name: 'Gerais',
      icon: 'fa fa-cogs fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('conf_gerais'),
      link: '/app/config/gerais',
    },
    {
      name: 'Layouts',
      ativo: !(
        podeAcessar('conf_layouts_imp') == false &&
        podeAcessar('conf_layouts_hig') == false
      ),
      type: 'collapse',
      icon: 'fa fa-cog fa-fw',
      iconSize: '1.2em',
      children: [
        {
          name: 'Importação',
          type: 'item',
          ativo: podeAcessar('conf_layouts_imp'),
          link: '/app/config/layout-importacao',
        },
        {
          name: 'Higienização',
          type: 'item',
          ativo: podeAcessar('conf_layouts_hig'),
          link: '/app/config/layout-higienizacao',
        },
      ],
    },
    {
      name: 'Status',
      ativo: !(
        podeAcessar('conf_status_proc') == false &&
        podeAcessar('conf_status_hist') == false
      ),
      type: 'collapse',
      icon: 'fa fa-cog fa-fw',
      iconSize: '1.2em',
      children: [
        {
          name: 'Processo/Devedor',
          type: 'item',
          ativo: podeAcessar('conf_status_proc'),
          link: '/app/config/status-processo',
        },
        {
          name: 'Histórico/Ocorrência',
          type: 'item',
          ativo: podeAcessar('conf_status_hist'),
          link: '/app/config/status-ocorrencia',
        },
        {
          name: 'Classificação de Títulos',
          type: 'item',
          ativo: podeAcessar('conf_classifica_tit'),
          link: '/app/config/classificacao-titulo',
        },
      ],
    },
    {
      name: 'Acesso / Segurança',
      ativo: !(
        podeAcessar('conf_ip_liberado') == false &&
        podeAcessar('conf_horario_acesso') == false &&
        podeAcessar('conf_politica_de_senhas') == false
      ),
      type: 'collapse',
      icon: 'fa fa-lock fa-fw',
      iconSize: '1.2em',
      children: [
        {
          name: 'Liberação de IP',
          type: 'item',
          ativo: podeAcessar('conf_ip_liberado'),
          link: '/app/config/controle-de-acesso-ip',
        },
        {
          name: 'Horários de Acesso',
          type: 'item',
          ativo: podeAcessar('conf_horario_acesso'),
          link: '/app/config/controle-de-acesso-horarios',
        },
        {
          name: 'Políticas de Senhas',
          type: 'item',
          ativo: true || podeAcessar('conf_politica_de_senhas'),
          link: '/app/config/politicas-de-senha',
        },
        {
          name: 'LDAP',
          type: 'item',
          ativo: true,
          link: '/app/config/ldap',
        },
      ],
    },
    {
      name: 'Contas de E-mail',
      icon: 'fa fa-envelope fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('conf_emails'),
      link: '/app/config/email',
    },
    {
      name: 'Níveis de Acesso',
      icon: 'fa fa-list fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('conf_niveis'),
      link: '/app/config/niveis-acesso',
    },
    {
      name: 'Integrações',
      icon: 'fa fa-sitemap fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('conf_gerais'),
      link: '/app/config/integracoes',
    },
    {
      name: 'Integrações V2',
      icon: 'fa fa-plug fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: false, //podeAcessar('conf_gerais'),
      link: '/app/config/integracoes-v2',
    },
    {
      name: 'Automações',
      icon: 'fa fa-cogs fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: podeAcessar('automacoes'),
      link: '/app/config/automacoes',
    },
    {
      name: 'Produtos Adicionais',
      icon: 'fa fa-money fa-fw',
      iconSize: '1.2em',
      type: 'item',
      ativo: true,
      link: '/app/config/produtos',
    },
    {
      name: 'Cronograma de Treinamento',
      type: 'item',
      ativo: true,
      link: '/app/config/treinamento',
    },
  ];
}
